import { Routes, Route } from 'react-router-dom';
import { MineModelDto, useMineModelQuery } from 'providers/api';
import { useScenario } from 'modules/project/providers/scenario';
import ModelDrawer from '../../ModelDrawer';
import { navigateToScene, SceneProps, SceneSideDrawerRoute } from '../scene-utils';
import { Model } from '../../hooks/useModelState';
import EditorPanel from '../../EditorPanelPage/EditorPanelPage';
import { useMarquee } from '../../contexts/MarqueeContext';

const EditorPanelWrapper = ({ model, onClose }: { model: Model; onClose: () => void }) => {
  const { activeScenarioId } = useScenario();
  const mineModelQuery = useMineModelQuery({
    mineModelId: model.project?.entityId ?? '',
    scenarioId: activeScenarioId ?? undefined,
  });
  if (!model.project) return null;
  return (
    <EditorPanel
      model={model}
      project={model.project}
      mineModel={mineModelQuery.data as MineModelDto}
      mineModelQuery={mineModelQuery}
      onClose={onClose}
    />
  );
};

const manuelNodesSceneSideDrawerRoutes = (
  model: Model,
  _path: string,
  _baseUrl: string,
  currentDrawerState: boolean,
  setDrawerStateCallback: (isOpen: boolean) => void,
  handleBackCallback: () => void,
): SceneSideDrawerRoute[] => [
    {
      path: '*',
      isOpen: currentDrawerState,
      setIsOpen: setDrawerStateCallback,
      component: model && <EditorPanelWrapper model={model} onClose={handleBackCallback} />,
      backNavText: 'Stopes', // msgid; ModelDrawer translates it
      onBack: handleBackCallback,
    },
  ];

const SideDrawerContent = ({ props, model }: { props: SceneProps; model: Model }) => {
  const marquee = useMarquee();

  const handleBack = () => {
    marquee.setMarqueeMode(false);
    navigateToScene('DEFAULT', { model, context: props.context });
  };

  const routes = manuelNodesSceneSideDrawerRoutes(
    model,
    props.meta.path,
    props.meta.url,
    props.context.state.drawerOpen,
    props.context.actions.setDrawerOpen,
    handleBack,
  );

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={(
            <ModelDrawer
              isOpen={route.isOpen}
              setIsOpen={route.setIsOpen}
              backNavText={route.backNavText as string}
              onBack={handleBack}
            >
              {route.component}
            </ModelDrawer>
          )}
        />
      ))}
    </Routes>
  );
};

const sideDrawerContent = (
  props: SceneProps,
  model: Model,
): JSX.Element => (
  <SideDrawerContent props={props} model={model} />
);

export default sideDrawerContent;
